<template>
  <div class="d-inline-block">
    <span class="button-animation__container d-flex">
      <template>
        <span v-hotkey="keymap" />
      </template>
      <image-box-tool-with-options
        v-if="show"
        ref="menu"
        class="animate-image__select"
        v-bind="{
          title: label,
          icon,
          align: 'none'
        }"
      >
        <div
          v-for="(option, index) in animationOptions"
          :key="`anim_option_${index}`"
          class="image-box__option"
          :class="{'image-box__option--selected': selectedOption === option}"
          @click="selectOption(option)"
        >
          <base-icon
            v-if="selectedOption === option"
            icon="colored-check"
            class="image-box__option__icon"
          /> {{ option }}
        </div>
      </image-box-tool-with-options>
      <transition name="fade">
        <button
          v-show="animate"
          class="image-row__button preview-button"
          @click="showPreview"
        >
          <div class="d-flex align-items-center">
            <base-link-with-icon
              size="r"
              icon="preview-icon"
            >Preview</base-link-with-icon>
          </div>
        </button>
      </transition>
      <base-modal
        id="animatedImagePreview"
        :show-footer="true"
        :show-close-button="true"
        style="min-height: 16rem"
        :title="waitingPatch || !previewLoaded ? 'Generating' : ' '"
        :show="showAnimationModal"
        @closed="closeModal"
      >
        <base-loading
          :show="waitingPatch || !previewLoaded"
          :label="`Please wait ${loadTooLong ? '(This is taking longer than usual)' : ''}`"
        />

        <div v-show="!waitingPatch && previewLoaded">
          <img
            v-if="sectionId !== null"
            :key="previewTimestamp"
            :src="gifSource"
            alt="animated preview"
            width="100%"
            @load="previewLoaded = true"
          >
        </div>
      </base-modal>
    </span>
  </div>
</template>
<script>
import { EventBus } from '@/event-bus';
import { API_ROOT, SVG2GIF_API } from '@/config';
import ImageBoxTool from './ImageBoxTool';

const options = {
  SLIDE_SHOW: 'Slide Show',
  LOOP: 'Loop',
  DISABLE: 'Disable',
};

export default {
  name: 'AnimateImageImageBoxTool',
  extends: ImageBoxTool,
  data() {
    return {
      icon: 'animation',
      hotkey: 'alt+a',

      animate: false,
      sectionId: null,

      waitingPatch: false,
      showAnimationModal: false,
      previewLoaded: false,
      previewTimestamp: Date.now(),
      showOptions: false,
      animationOptions: [options.LOOP, options.DISABLE],

      loadTooLong: false,
      loadTooLongTimeout: null,
    };
  },
  computed: {
    keymap() {
      const keymapDict = {};
      keymapDict[this.hotkey] = this.action;
      return keymapDict;
    },
    label() {
      return this.selectedOption === options.DISABLE ? 'Animation' : this.selectedOption;
    },
    selectedOption() {
      return this.animate ? options.LOOP : options.DISABLE;
    },
    gifSource() {
      if (!this.sectionId) {
        return '';
      }
      const backendUrl = new URL(API_ROOT);
      if (['localhost', '0.0.0.0', '127.0.0.1'].includes(backendUrl.hostname.toLowerCase())) {
        return '';
      }
      return `${SVG2GIF_API}/${this.sectionId}/?domain=${backendUrl.hostname}&port=${backendUrl.port}&protocol=${backendUrl.protocol.replace(':', '')}`;
    },
  },
  mounted() {
    this.animate = this.parent.options
      ? this.parent.options.animated
      : this.animate;

    // This is triggered on animation preview request. Backend patches current image, and only then we request gif service.
    EventBus.$on('image-section:patch-result', (success, sectionId) => {
      if (this.waitingPatch) {
        this.waitingPatch = false;
        if (success) {
          // udpate image
          this.sectionId = sectionId;
          this.previewTimestamp = Date.now();
          if (this.loadTooLongTimeout) {
            window.clearTimeout(this.loadTooLongTimeout);
          }
          this.loadTooLongTimeout = window.setTimeout(() => {
            if (!this.previewLoaded) {
              this.loadTooLong = true;
            }
          }, 10000);
        } else {
          console.log('Problems patching section');
          EventBus.$emit('toast-error', 'There was an error loading the preview');
        }
      }
    });
  },
  methods: {
    action() {
      // this.animate = true;
      this.showOptions = !this.showOptions;
      // this.$emit("change", { animated: this.animate });
    },
    showPreview() {
      // patch section
      this.showAnimationModal = true;
      this.waitingPatch = true;
      this.$emit('change', { force_save: true });
      // Wait response
      // show preview
    },
    closeModal() {
      this.showAnimationModal = false;
      this.previewLoaded = false;
      this.waitingPatch = false;
      this.loadTooLong = false;
      this.loadTooLongTimeout = null;
      this.sectionId = null;
    },
    selectOption(option) {
      this.showOptions = false;
      this.animate = option !== options.DISABLE;
      this.$emit('change', { animated: this.animate });
    },
  },
};
</script>
<style lang="scss" scoped>
.animate-image__select{
  // min-width: 120px;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s;
}

.fade-enter,
.fade-leave-to

/* .fade-leave-active below version 2.1.8 */
 {
  opacity: 0;
}
.image-box__option{
  padding-left: 30px !important;
  min-width: 102px;
  font-size: 0.8125rem;
  height: 24px !important;
  &__icon{
    margin-right: 12px;
  }
}
.image-box__option.image-box__option--selected{
  border: none !important;
  color: $clementine;
  padding-left: 5px !important;
}
::v-deep .image-box-with-options__submenu{
  bottom: calc(100% + 0px) !important;
  box-shadow: none !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}
// .image-box__option image-box__option--selected
</style>
